module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABIBAMAAACnw650AAAAGFBMVEUAAABUQz5UQj1URD5bSUBVQz1UQj1UQj3hKr0oAAAAB3RSTlMA5qaIHO1k9sCU0QAAAHJJREFUSMdjGOaARbEcLxByACpyLScAQoCK1AkpKgIqEiekqBCoqLwcj4PB8qOKRhWNKhpVNKqI+ooIF9HEFvaEqw3iKiB0AJFAFSNXUVk6lRQBweBRxCyOFmUGWBSZowd1MRZF4hixT64iTOuIc/jIAABugwUKgvz2fAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/download/download_icon_pac_selected.png
// module id = g5SP
// module chunks = 10